import { DeveloperToolsPane } from "./DeveloperToolsPane";
import { isAutomatedBrowser } from "./is-automated-browser";
import { useShellRuntime } from "../shell-runtime";
import { useShellViewLoadState } from "../router/use-shell-view-load-state";

function shouldMountDeveloperTools(
  viewLoadState: ReturnType<typeof useShellViewLoadState>,
): boolean {
  return viewLoadState.status === "ready" || viewLoadState.status === "error";
}

/**
 * Mounts {@link DeveloperToolsPane} when the host injects `developerTools.enabled`
 * and the view bundle has settled (loaded or failed). Hidden while the bundle is
 * still loading and during browser automation (Playwright / Chromatic).
 */
export function DeveloperToolsHost() {
  const { developerTools } = useShellRuntime();
  const viewLoadState = useShellViewLoadState();

  if (developerTools?.enabled !== true || isAutomatedBrowser()) {
    return null;
  }

  if (!shouldMountDeveloperTools(viewLoadState)) {
    return null;
  }

  return <DeveloperToolsPane />;
}
